/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Downloaddisclaimer1Inputs */

const id_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran unduhan penuh adalah ukuran terkompresi setiap build lengkap, bukan perkiraan pembaruan atau patch.`)
};

const ms_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiz muat turun penuh ialah saiz termampat bagi setiap binaan lengkap, bukan anggaran kemas kini atau tampalan.`)
};

const da_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den fulde downloadstørrelse er den komprimerede størrelse af hvert komplette build, ikke et estimat for en opdatering eller patch.`)
};

const de_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die vollständige Downloadgröße ist die komprimierte Größe jedes vollständigen Builds, keine Schätzung für ein Update oder einen Patch.`)
};

const en_us2_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full download size is the compressed size of each complete build, not an update or patch estimate.`)
};

const es_es2_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El tamaño de descarga completa es el tamaño comprimido de cada compilación completa, no una estimación de actualización o parche.`)
};

const es_mx2_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El tamaño de descarga completa es el tamaño comprimido de cada compilación completa, no una estimación de actualización o parche.`)
};

const fil_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang buong laki ng download ay ang naka-compress na laki ng bawat kumpletong build, hindi pagtatantya ng update o patch.`)
};

const fr_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La taille du téléchargement complet correspond à la taille compressée de chaque build complet, et non à une estimation de mise à jour ou de correctif.`)
};

const it_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dimensione del download completo è la dimensione compressa di ogni build completa, non una stima di aggiornamento o patch.`)
};

const hu_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A teljes letöltési méret minden teljes build tömörített mérete, nem pedig frissítés- vagy javításbecslés.`)
};

const nl_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De volledige downloadgrootte is de gecomprimeerde grootte van elke volledige build, geen schatting van een update of patch.`)
};

const no_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full nedlastingsstørrelse er den komprimerte størrelsen på hver komplette build, ikke et estimat for en oppdatering eller oppdateringspakke.`)
};

const pl_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełny rozmiar pobierania to skompresowany rozmiar każdego kompletnego buildu, a nie szacowany rozmiar aktualizacji lub poprawki.`)
};

const pt_br2_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tamanho do download completo é o tamanho compactado de cada build completo, não uma estimativa de atualização ou patch.`)
};

const pt_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tamanho da transferência completa é o tamanho comprimido de cada compilação completa, não uma estimativa de atualização ou patch.`)
};

const ro_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensiunea descărcării complete este dimensiunea comprimată a fiecărui build complet, nu o estimare pentru o actualizare sau o corecție.`)
};

const fi_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täyden latauksen koko on jokaisen kokonaisen buildin pakattu koko, ei päivityksen tai paikkauksen arvio.`)
};

const sv_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den fullständiga nedladdningsstorleken är den komprimerade storleken för varje komplett build, inte en uppskattning av en uppdatering eller patch.`)
};

const vi_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kích thước tải xuống đầy đủ là kích thước nén của mỗi build hoàn chỉnh, không phải ước tính cập nhật hoặc bản vá.`)
};

const tr_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam indirme boyutu her eksiksiz derlemenin sıkıştırılmış boyutudur; güncelleme veya yama tahmini değildir.`)
};

const cs_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velikost úplného stažení je komprimovaná velikost každého celého buildu, nikoli odhad aktualizace nebo patche.`)
};

const bg_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пълният размер за изтегляне е компресираният размер на всяка цяла компилация, а не оценка за актуализация или пач.`)
};

const ru_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полный размер загрузки — это сжатый размер каждой полной сборки, а не оценка обновления или патча.`)
};

const uk_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повний розмір завантаження — це стиснений розмір кожного повного білду, а не оцінка оновлення чи патчу.`)
};

const ar_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حجم التنزيل الكامل هو الحجم المضغوط لكل بناء كامل، وليس تقديرًا لتحديث أو تصحيح.`)
};

const hi_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण डाउनलोड आकार हर पूरे बिल्ड का संपीड़ित आकार है, अपडेट या पैच का अनुमान नहीं।`)
};

const th_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขนาดดาวน์โหลดทั้งหมดคือขนาดบีบอัดของบิลด์เต็มแต่ละรายการ ไม่ใช่ค่าประมาณการอัปเดตหรือแพตช์`)
};

const ja_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全ダウンロードサイズは各完全ビルドの圧縮サイズであり、更新やパッチの推定値ではありません。`)
};

const zh_cn2_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整下载大小是每个完整构建的压缩大小，不是更新或补丁大小的估算。`)
};

const zh_hant1_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整下載大小是每個完整組建的壓縮大小，不是更新或修補程式大小的估計。`)
};

const ko_builds_comparison_downloaddisclaimer1 = /** @type {(inputs: Builds_Comparison_Downloaddisclaimer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 다운로드 크기는 각 전체 빌드의 압축된 크기이며 업데이트나 패치의 예상치가 아닙니다.`)
};

/**
* | output |
* | --- |
* | "Full download size is the compressed size of each complete build, not an update or patch estimate." |
*
* @param {Builds_Comparison_Downloaddisclaimer1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_downloaddisclaimer1 = /** @type {((inputs?: Builds_Comparison_Downloaddisclaimer1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Downloaddisclaimer1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "ms") return ms_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "da") return da_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "de") return de_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "fil") return fil_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "fr") return fr_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "it") return it_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "hu") return hu_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "nl") return nl_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "no") return no_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "pl") return pl_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "pt") return pt_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "ro") return ro_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "fi") return fi_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "sv") return sv_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "vi") return vi_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "tr") return tr_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "cs") return cs_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "bg") return bg_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "ru") return ru_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "uk") return uk_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "ar") return ar_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "hi") return hi_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "th") return th_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "ja") return ja_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_downloaddisclaimer1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_downloaddisclaimer1(inputs)
	return ko_builds_comparison_downloaddisclaimer1(inputs)
});
export { builds_comparison_downloaddisclaimer1 as "builds.comparison.downloadDisclaimer" }